import { formatWithMinDigits } from "../../../../../utility/utils";

export const formatIdBultoSkim = (item) => {
    if (!item) return "";
    if (item.recepcion_display_id){
        return `R-${item.recepcion_display_id}`;
    }
    if (item.recepcion) {
        return `R-${item.recepcion}`;
    } else {
        return `B-${formatWithMinDigits(item.id, 4)}`;
    }
};

export const formatOpcionBultoLabel = (item) => {
    if (!item) return "";
    const id = formatIdBultoSkim(item);
    const restante = item.kg_humedos_actual
        ? Number(item.kg_humedos_actual).toLocaleString('es-GT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
        : "0.00";

    return `${id} - ${restante} kg`;
}

// Nombre del consumidor final de un EVS, con guion cuando el EVS todavía no lo tiene asignado
export const formatConsumidorFinalEVS = (evs) => {
    if (!evs) return "";
    if (!evs.consumidor_final) return "No asignado";
    return evs.consumidor_final.nombre;
};

// Texto que se muestra al pasar el cursor sobre el cliente de un EVS
export const formatTitleConsumidorFinalEVS = (evs) => {
    if (!evs) return "";
    return `Consumidor final: ${formatConsumidorFinalEVS(evs)}`;
};
